import { Breadcrumbs as MuiBreadcrumbs, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import type { ReactNode } from 'react';

export interface Crumb {
  label: ReactNode;
  to?: string;
}

export interface BreadcrumbsProps {
  items: Crumb[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <MuiBreadcrumbs aria-label="breadcrumb" sx={{ mb: 2, fontSize: '0.875rem' }}>
      {items.map((c, idx) => {
        const last = idx === items.length - 1;
        if (last || !c.to) {
          return (
            <Typography
              key={idx}
              component="span"
              sx={{
                color: 'text.secondary',
              }}
            >
              {c.label}
            </Typography>
          );
        }
        return (
          <MuiLink key={idx} component={RouterLink} to={c.to} underline="hover" color="inherit">
            {c.label}
          </MuiLink>
        );
      })}
    </MuiBreadcrumbs>
  );
}
